module.exports = __webpack_public_path__ + "img/si.ef8f2f82.svg";